import PropTypes from 'prop-types'
import TextInput from 'components/form/TextInput'

import { setSiteName } from 'features/channel/add/channelAddSlice'
import { useDispatch, useSelector } from 'react-redux'
import Table from 'components/table/Table'
import ErrorText from 'components/form/ErrorText'

const ChannelName = ({ error, isEditable }) => {
  const dispatch = useDispatch()
  const { name } = useSelector(state => state.channel.channelAdd)

  return (
    <Table.Row className="tr_site" error={error}>
      <th scope="row">
        <div className="inner_tbl">비즈채널명</div>
      </th>
      <td>
        <div className="inner_tbl">
          <TextInput
            focusOnError
            error={error}
            trim
            placeholder="비즈채널명"
            maxLength={12}
            value={name}
            disabled={!isEditable}
            onValueChange={v => dispatch(setSiteName(v))}
          />
          <ErrorText error={error} />
        </div>
      </td>
    </Table.Row>
  )
}
export default ChannelName

ChannelName.propTypes = {
  error: PropTypes.string,
  isEditable: PropTypes.bool,
}
